import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
    bio: '',
    headshotUrl: '',
    buttonText: '',
    showStats: true,
    showRateCard: true,
    showInquiryForm: true,
    layout: 'card',
    stats: null,
    rateCard: [],
  },
  blockDesign: {
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
};

export const mediaKitSlice = createSlice({
  name: 'mediaKit',
  initialState,
  reducers: {
    mediaKitStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = buttonDesign ?? {};
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
        bio: blockContent.bio ?? '',
        headshotUrl: blockContent.headshotUrl ?? '',
        buttonText: blockContent.buttonText ?? '',
        showStats: blockContent.showStats !== false,
        showRateCard: blockContent.showRateCard !== false,
        showInquiryForm: blockContent.showInquiryForm !== false,
        layout: blockContent.layout ?? 'card',
        stats: blockContent.stats ?? null,
        rateCard: blockContent.rateCard ?? [],
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    mediaKitClear: () => initialState,

    mediaKitUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    mediaKitUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    mediaKitUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    mediaKitUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const {
  mediaKitStore,
  mediaKitClear,
  mediaKitUpdateIsLoading,
  mediaKitUpdateIsActive,
  mediaKitUpdateBlockContent,
  mediaKitUpdateBlockDesign,
} = mediaKitSlice.actions;

export const selectMediaKitIsLoading = (state) => state.mediaKit.isLoading;

export const selectMediaKitId = (state) => state.mediaKit.id;
export const selectMediaKitUID = (state) => state.mediaKit.uid;
export const selectMediaKitSID = (state) => state.mediaKit.sid;

export const selectMediaKitBlockContent = (state) => state.mediaKit.blockContent;

export const selectMediaKitSortItems = createSelector([selectMediaKitBlockContent], ({ rateCard }) => {
  return sortItems(rateCard ?? []);
});

export const selectMediaKitBlockDesign = (state) => state.mediaKit.blockDesign;
export const selectMediaKitButtonDesign = (state) => state.mediaKit.buttonDesign;
export const selectMediaKitItemDesign = (state) => state.mediaKit.itemDesign;
export const selectMediaKitContainerDesign = (state) => state.mediaKit.containerDesign;

export default mediaKitSlice.reducer;
